import { InclusiveExclusiveModelComparator } from './comparators/inclusive-exclusive-model-comparator';
import {
  InclusiveExclusiveFilterModel,
  IFilterComparator,
  ConfigureOptionsParams,
  FilterOptions,
  FilterPassParams
} from '../filter-types';
import { CalendarGridColumnName } from '../../../grid/types/column.types';
import { FilterResultFacade } from '../filter-result-facade';
import { filterInclusiveExclusiveValues } from '../filter-utils';
import { stateValueGetter } from '../../../grid/utils/value-getters/state';
import { FilterHandlerBase } from './base/filter-handler-base';

export class StateFilterHandler extends FilterHandlerBase {
  private comparator: IFilterComparator<InclusiveExclusiveFilterModel>;

  get name(): string {
    return CalendarGridColumnName.State;
  }

  get isInclusiveExclusive(): boolean {
    return true;
  }

  configureFilterOptions(params: ConfigureOptionsParams): void {
    params.setFilterService.states = params.filterOptions.states;
  }

  getFilterOptions(filterOptions: FilterOptions): any {
    return Object.keys(filterOptions.states);
  }

  hasValidDiff(options: FilterOptions, grid: any, store: any): boolean {
    return this.getValidDiffComparator(options).hasValidDiff(grid, store);
  }

  getValidDiffComparator(
    options: FilterOptions
  ): IFilterComparator<InclusiveExclusiveFilterModel> {
    if (!this.comparator) {
      this.comparator = new InclusiveExclusiveModelComparator();
    }
    this.comparator.applyFilterOptions(this.getFilterOptions(options));
    return this.comparator;
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    let stateFilterPassed = true;
    const state = params.filters[this.name];
    const data = params.deal;
    const filterOptions = params.options;
    if (state) {
      const model: InclusiveExclusiveFilterModel = state.model as InclusiveExclusiveFilterModel;
      stateFilterPassed = filterInclusiveExclusiveValues(
        model,
        stateValueGetter({ data }),
        Object.keys(filterOptions.states)
      );
    }
    result.applyDealFilerResult(data.id, this.name, stateFilterPassed);

    return stateFilterPassed;
  }
}
